export const FROM_DATE_LIMIT = {
  THREE_MONTHS: "THREE_MONTHS",
  ONE_HUNDRED_EIGHTY_DAYS: "ONE_HUNDRED_EIGHTY_DAYS",
  ONE_YEAR: "ONE_YEAR"
};

export const FROM_TO_KEYWORDS = {
  FROM: "from",
  TO: "to",
  START_DATE: "startDate",
  END_DATE: "endDate"
};
